module.exports = __webpack_public_path__ + "img/icon-data-gray.72875728.svg";